import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd">
      <path d="M6 6.998v6h6v2H4v-8z" />
      <path d="M14.241 4.85c2.552-.675 5.271-.134 7.99 1.218.932.463 1.8.992 2.581 1.544.414.292.73.536.931.704l.838.72-1.304 1.516-.758-.652c-.148-.127-.442-.36-.86-.654a17.745 17.745 0 0 0-2.318-1.387c-2.325-1.157-4.584-1.605-6.589-1.076-1.716.454-3.354 1.532-4.87 3.071a19.424 19.424 0 0 0-2.667 3.417l-.294.499-.492.922-1.765-.94.47-.883c.159-.298.454-.795.878-1.42a21.398 21.398 0 0 1 2.445-2.998c1.748-1.774 3.677-3.045 5.784-3.601ZM26 23.998v-6h-6v-2h8v8z" />
      <path d="M17.259 27.09c-2.552.675-5.271.134-7.99-1.218a19.726 19.726 0 0 1-2.581-1.544c-.414-.292-.73-.536-.931-.704l-.838-.72 1.304-1.516.758.652c.148.127.442.36.86.654.703.496 1.484.973 2.318 1.387 2.325 1.157 4.584 1.605 6.589 1.076 1.716-.454 3.354-1.532 4.87-3.071a19.424 19.424 0 0 0 2.667-3.417l.294-.499.492-.922 1.765.94-.47.883c-.159.298-.454.795-.878 1.42a21.398 21.398 0 0 1-2.445 2.998c-1.748 1.774-3.677 3.045-5.784 3.601Z" />
    </g>
  </svg>
);
export default SvgIcRefresh;
